import React from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import "./styles/_vwstyle.scss";
import Footer from "./components/Footer";
import Header from "./components/Header";
import KeepMeInformed from "./aplicaciones/keepmeinformed";
import UsuariosXAplicacion from "./aplicaciones/admin/usuarioxaplicacion";
import NotificacionesUsuario from "./aplicaciones/admin/notificacionesusuario";
import Aplicacion from "./aplicaciones/admin/aplicaciones";
import Rol from "./aplicaciones/admin/rol";
import PermisosRol from "./aplicaciones/admin/permisosRol";
import { ProtectedRoute } from "autenticacion_protectedroute";
import Callback from "autenticacion_callback";
import NoEncontrado from "./aplicaciones/genericos/NoEncontrado";
import Inicio from "./aplicaciones/genericos/inicio";
import AyudaSalesforce from "./aplicaciones/ayudaSalesforce";
import Contenido from "./aplicaciones/ayudaSalesforce/Contenido";
import Ideas from "./aplicaciones/ideasNetWorking/index";
import TipoAutenticacion from "./aplicaciones/admin/tipoAutenticacion";
import Destinatarios from "./aplicaciones/admin/destinatarios";
import AccesosPermanentes from "./aplicaciones/admin/accesosPermanentes";
import Estados from "./aplicaciones/admin/Soporte/Estados/Estados";
import Canales from "./aplicaciones/admin/canales";
import Concesionarias from "./aplicaciones/admin/concesionarias";
import SoporteAakdigital from "./aplicaciones/aakdigital/soporte";
import Transacciones from "./aplicaciones/admin/transacciones";
import Comunicados from "./aplicaciones/admin/comunicados";
import Monitoreos1 from "./aplicaciones/especialista/Monitoreos";
import Monitoreo1 from "./aplicaciones/especialista/Monitoreos/Monitoreo";
import Libreria from "./aplicaciones/especialista/Libreria";
import Polly from "./aplicaciones/especialista/Polly";
import Logs from "./aplicaciones/especialista/Logs";
import Avisos from "./aplicaciones/admin/avisos";
import SoporteAvisoPrivacidad from "./aplicaciones/avisoPrivacidad/soporte";
import SoporteCentroTecnico from "./aplicaciones/centroTecnico/soporte";

import { obtenerEstado } from "./utils/obtenerEstado";
import analytics from "./lib/analytics";

analytics.init(process.env.REACT_APP_ANALITICAS_URL)

const App = {
  dependencies: {
    featureServices: {
      "dto:servicio:autenticacion": "^1.0.0",
    },
  },
  create(env) {
    const servicio = env.featureServices["dto:servicio:autenticacion"];
    return {
      render() {
        return (
          <div className="contenedor">
            <Header servicio = {servicio} />
            <React.Fragment>
              <BrowserRouter>
              <Switch>
                <Route
                  path="/SigueTuVehiculo/"
                  exact={true}
                  render={(routeProps) => (
                    <KeepMeInformed
                      {...routeProps}
                      mainUrl="https://kmi.vwmapps.com.mx/"
                    />
                  )}
                />

                <Route
                  path="/ideasNetWorking/"
                  exact={true}
                  render={(routeProps) => (
                    <Ideas servicio={servicio} {...routeProps} />
                  )}
                />

                <Route
                  path="/oauth/callback"
                  exact={true}
                  render={(routeProps) => (
                    <Callback spinner={true} servicio={servicio} {...routeProps} />
                  )}
                />

                <ProtectedRoute
                  exact={true}
                  path="/vw/admin"
                  servicio={servicio}
                  marca="vw"
                  component={Inicio}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/usuarioxaplicacion"
                  servicio={servicio}
                  marca="vw"
                  component={UsuariosXAplicacion}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/aplicaciones"
                  servicio={servicio}
                  marca="vw"
                  component={Aplicacion}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/roles"
                  servicio={servicio}
                  marca="vw"
                  component={Rol}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/permisosrol"
                  servicio={servicio}
                  marca="vw"
                  component={PermisosRol}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/tipoautenticacion"
                  servicio={servicio}
                  marca="vw"
                  component={TipoAutenticacion}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/notificacionesusuario"
                  servicio={servicio}
                  marca="vw"
                  component={NotificacionesUsuario}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/destinatarios"
                  servicio={servicio}
                  marca="vw"
                  component={Destinatarios}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/accesospermanentes"
                  servicio={servicio}
                  marca="vw"
                  component={AccesosPermanentes}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/estados"
                  servicio={servicio}
                  marca="vw"
                  component={Estados}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/canales"
                  servicio={servicio}
                  marca="vw"
                  component={Canales}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/concesionarias"
                  servicio={servicio}
                  marca="vw"
                  component={Concesionarias}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/soporte-aakdigital"
                  servicio={servicio}
                  marca="vw"
                  component={SoporteAakdigital}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/soporte-avisoprivacidad"
                  servicio={servicio}
                  marca="vw"
                  component={SoporteAvisoPrivacidad}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/soporte-ct"
                  servicio={servicio}
                  marca="vw"
                  component={SoporteCentroTecnico}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/transacciones"
                  servicio={servicio}
                  marca="vw"
                  component={Transacciones}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/comunicados"
                  servicio={servicio}
                  marca="vw"
                  component={Comunicados}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/admin/avisos"
                  servicio={servicio}
                  marca="vw"
                  component={Avisos}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/especialista/monitoreos"
                  servicio={servicio}
                  onObtenerEstado = {obtenerEstado}
                  marca="vw"
                  component={Monitoreos1}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/especialista/monitoreo"                  
                  servicio={servicio}
                  onObtenerEstado = {obtenerEstado}
                  marca="vw"
                  component={Monitoreo1}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/especialista/libreria"
                  servicio={servicio}
                  marca="vw"
                  component={Libreria}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/especialista/polly"
                  servicio={servicio}
                  marca="vw"
                  component={Polly}
                />
                <ProtectedRoute
                  exact={true}
                  path="/vw/especialista/logs"
                  servicio={servicio}
                  marca="vw"
                  component={Logs}
                />
                <Route path="/vw/ayuda" exact={true}>
                  <AyudaSalesforce marca="vw" />
                </Route>
                <Route path="/vw/ayuda/salesforce" exact={true}>
                  <Contenido marca="vw" />
                </Route>
                <Route>
                  <NoEncontrado />
                </Route>
              </Switch>
            </BrowserRouter>
            </React.Fragment>
            <Footer />
          </div>
        );
      },
    };
  },
};

export default App;
